import { render } from "./RuiOxygen.vue?vue&type=template&id=23a6423e"
const script = {}
script.render = render

export default script